// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__17Lek","column":"style_column__1lKjo"};